import React from 'react';

import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  TypingIndicator,
} from '@chatscope/chat-ui-kit-react';

import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';

import config from './../config';

const {baseUrl, key} = config.api;

export default function ChatWidget({
  session_id,
  window_title,
  minimized,
  onToggleMinimize,
  onClose,
}) {
  const [messages, setMessages] = React.useState([
    {
      message: 'Hola, ¿en qué puedo ayudarte?',
      sender: 'bot',
      direction: 'incoming',
    },
  ]);

  const [loading, setLoading] = React.useState(false);

  const handleSend = async text => {
    const userMessage = {
      message: text,
      sender: 'user',
      direction: 'outgoing',
    };

    setMessages(prev => [...prev, userMessage]);

    setLoading(true);

    try {
      const response = await fetch(`${baseUrl}/v1/candidatosIA/chat/query`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': key,
        },
        body: JSON.stringify({
          query: text,
          session_id,
        }),
      });

      if (!response.ok) {
        throw new Error('Error al procesar el mensaje');
      }

      const data = await response.json();

      setMessages(prev => [
        ...prev,
        {
          message: data.message || 'No recibí una respuesta válida.',
          sender: 'bot',
          direction: 'incoming',
        },
      ]);
    } catch (error) {
      console.error(error);

      setMessages(prev => [
        ...prev,
        {
          message: 'Ocurrió un error al enviar el mensaje. Intentá nuevamente.',
          sender: 'system',
          direction: 'incoming',
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  if (minimized) {
    return (
      <div
        style={{
          marginRight: 6,
          position: 'relative',
          width: 32,
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <button
          type="button"
          title={window_title || 'Chat'}
          onClick={event => {
            event.stopPropagation();
            onToggleMinimize?.(session_id);
          }}
          style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            border: '1px solid #d6a400',
            backgroundColor: '#fbff22',
            color: '#966b00',
            cursor: 'pointer',
            fontSize: 15,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
            padding: 0,
          }}>
          💬
        </button>

        <button
          type="button"
          onClick={event => {
            event.stopPropagation();
            onClose?.(session_id);
          }}
          style={{
            position: 'absolute',
            top: -4,
            right: -4,
            width: 14,
            height: 14,
            borderRadius: '50%',
            border: '1px solid #ccc',
            background: '#fff',
            color: '#333',
            cursor: 'pointer',
            fontSize: 9,
            lineHeight: '9px',
            padding: 0,
            zIndex: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          ×
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        marginRight: 8,
        position: 'relative',
        width: 360,
      }}>
      <div
        style={{
          height: 500,
          width: 360,
          border: '1px solid #ddd',
          borderRadius: 8,
          overflow: 'hidden',
          background: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}>
        <div
          style={{
            height: 38,
            backgroundColor: '#fbff22',
            color: '#966b00',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 8px 0 12px',
            borderBottom: '1px solid #ddd',
            fontWeight: 600,
            fontSize: 13,
          }}>
          <span>{window_title || 'Chat'}</span>

          <div style={{display: 'flex', gap: 6}}>
            <button
              type="button"
              onClick={event => {
                event.stopPropagation();
                onToggleMinimize?.(session_id);
              }}
              style={{
                width: 22,
                height: 22,
                borderRadius: '50%',
                border: '1px solid #ccc',
                background: '#fff',
                cursor: 'pointer',
                lineHeight: '18px',
                fontWeight: 'bold',
              }}>
              –
            </button>

            <button
              type="button"
              onClick={event => {
                event.stopPropagation();
                onClose?.(session_id);
              }}
              style={{
                width: 22,
                height: 22,
                borderRadius: '50%',
                border: '1px solid #ccc',
                background: '#fff',
                cursor: 'pointer',
                lineHeight: '18px',
                fontWeight: 'bold',
              }}>
              x
            </button>
          </div>
        </div>

        <div style={{height: 462}}>
          <MainContainer>
            <ChatContainer>
              <MessageList
                typingIndicator={
                  loading ? <TypingIndicator content="Escribiendo..." /> : null
                }>
                {messages.map((item, index) => (
                  <Message
                    key={`${item.sender}-${index}`}
                    model={{
                      message: item.message,
                      sender: item.sender,
                      direction: item.direction,
                      position: 'single',
                    }}
                  />
                ))}
              </MessageList>

              <MessageInput
                placeholder="Escribí tu mensaje..."
                attachButton={false}
                disabled={loading}
                onSend={handleSend}
              />
            </ChatContainer>
          </MainContainer>
        </div>
      </div>
    </div>
  );
}
